
<template>
  <div  class="">
    <div class="flx-center">
        <div class="businessBackground" :style="{ background: 'url(' + $ossUrl + 'images/business/overseas_banner.jpg) no-repeat center', backgroundSize: '100%' }"></div>
      </div>
    <div class="business">
      <!-- 美通海外仓 -->
        <div>
        <div class="container" >
             <div >
               <div class=" button-group">
                 <div class="button-group-item"  style="position: absolute;top:800px;">
                   <el-button
                    v-for="(item, index) in buttons"
                    :key="index"
                    :class="{ 'active': activeIndex === index }"
                    @click="setActive(item,index)"
                  >
                    <div class="btn-text" style="">
                     {{ item.label }}
                   </div>
                  </el-button>
                 </div>
               
                </div>
             </div>
              </div>
              <div style="position: relative;">
                <div class="business-imgRight">
                  <img :src="$ossUrl+'images/business/circel.png'" alt="">
               </div>
               <div class="container">
                <div class="service " style="position: relative;">
                     <div class="business-imgLeft">
                       <img :src="$ossUrl+'images/business/listen.png'" alt="">
                     </div>


                    <div class="service-text" style="padding-top: 70px;margin:130px 0 0 0px;">
                    <div >美通卡航</div><i class="serviceNews"></i></div>
                    <div class="flx-center">
                      <div class="service-content">
                        美通卡航派送目的国包括英国及欧盟国家，专业清关团队，零担拼车，自有车队尾程派送，时效稳定。DG货物发车频率高，运输安全。

                        </div>
                    </div>
                   </div>
               </div>
           </div>
      </div>
        <!-- 参考时效 -->
        <div class="service-text-bg" style="padding-bottom: 58px;">
          <div class="container ">
            <div class="service-text" style="padding-top: 70px;margin:130px 0 0 0px;">
              <div >参考时效</div><i class="serviceNews"></i></div>
             <el-row  style="margin-left: 25px;">
                <el-col :span="12">
                  <img class="referenceRoad flx-align-start" :src="$ossUrl+'images/business/air/European.png'" alt="" style="margin-top:70px;">

                  <!-- <div class="referenceRoad flx-align-start" style="margin-top:70px;">
                    <div class="referenceRoadContry">欧盟</div>
                    <div class="referenceRoadContent">16-18天</div>
                  </div> -->
                </el-col>
                <el-col :span="12">
                  <div class="referenceRoad flx-align-start" style="margin-top:70px;">
                    <div class="referenceRoadContry">英国</div>
                    <div class="referenceRoadContent">14-18天</div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="referenceRoad flx-align-start" style="margin-top:70px;">
                    <div class="referenceRoadContry">中亚、俄罗斯</div>
                    <div class="referenceRoadContent">16-19天</div>
                  </div>
                </el-col>
             </el-row>
        
          </div>
         
         
      
        </div> 
        <!-- 服务线路 -->
        <div class="container">
          <div class="service " style="padding: 100px 0 0 0;">
            <div class="service-text">
            <div >服务线路</div><i class="serviceNews"></i></div>
            <el-row style="margin-top: 70px;">
              <el-col :span="12" v-for="(item,index) in serviceList" :key="index">
                <div class="ServiceLineBox commonUI">
                      <div class="ServiceLineTitle">
                        <img style="width: 32px;margin-right: 16px;" v-if="item.icon" :src="item.icon" alt="icon" />{{item.title}}
                      </div>
                      <el-tabs v-model="item.activeName"  @tab-click="handleClick(item,index)">
                          <el-tab-pane label="产品渠道" name="first" v-if= "item.channelData">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.channelData">
                            </div> 
                          </el-tab-pane>
                          <el-tab-pane label="产品优势" name="second">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.goodData">
                              
                            </div> 
                          </el-tab-pane>
                          <el-tab-pane label="产品服务" name="third" v-if= "item.serviceData">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.serviceData">
                               
                            </div> 
                          </el-tab-pane>
                        </el-tabs>
                  </div>
              </el-col>
         
            </el-row>
          
           </div>
        </div>
        <!-- 运输流程 -->
        <!-- <div class="service-text-bg" style="padding-bottom: 180px;">
        
            <div class="container ">
            <div class="service-text" style="padding-top: 100px;margin:130px 0 0 0px;">
              <div >运输流程</div><i class="serviceNews"></i></div>
              </div>
          <div class="container " style="margin-top: 70px;position: relative;">
            <el-row>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation1.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">01</div>
                      <div class="transportationProContent">客户系统下单</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation2.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">05</div>
                      <div class="transportationProContent">到达监管仓</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation3.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">02</div>
                      <div class="transportationProContent">包裹装车发送至口岸</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation4.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">06</div>
                      <div class="transportationProContent">监管仓清关</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation5.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">03</div>
                      <div class="transportationProContent">口岸换装报关</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation6.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">07</div>
                      <div class="transportationProContent">尾程灵活派送</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation7.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">04</div>
                      <div class="transportationProContent">出境</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation8.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">08</div>
                      <div class="transportationProContent">AMZ仓库、第三方海外仓收货并上架</div>
                    </div>
                </div>
              </el-col>
            
              
            </el-row>
       
         
          </div>
        </div>  -->
    </div>
  </div>
</template>
<script>


/**
 * Index-1 component
 */
export default {
    name:"sea",
  components: {
  },
  data(){
    return {
      activeName:'first',
      activeIndex: 2, // 默认选中第一个按钮
      buttons: [
        { label: '海外仓',transportMode:'OCEAN' },
        { label: '头程海运',transportMode:'AIR' },
        { label: '头程卡航',transportMode:'RAIL' },
        { label: '头程空运',transportMode:'ROAD' }
      ],
      activePropsIndex:0,
      buttonProps: [
        { contry: '加拿大',capital:'温哥华/多伦多'},
        { contry: '美国',capital:'洛杉矶/芝加哥'}, 
        { contry: '墨西哥',capital:'墨西哥'},
        { contry: '英国',capital:'伦敦'},
        { contry: '比利时',capital:'烈日'},
        { contry: '德国',capital:'科隆'},
        { contry: '法国',capital:'巴黎'},
        { contry: '日本',capital:'大阪府'},
      ],
      serviceList:[
          {
            title:'欧盟卡航',
            activeName:'second',
            icon:this.$ossUrl+'images/business/overSea/OM.jpg',
            channelData:'深圳发车到列日LGG，16-18个自然日；',
            goodData:'自营监管仓、境外车队签约，每天发车；',
            serviceData:'清关模式：<br>1.单票清关，100%客户自主vat，递延清关（清关不交vat）；<br>2.拒接双清包税；<br>清关点：LGG、CDG，海外自建监管仓、清关团队。<br>尾程派送：快递派：UPS/DPD/DHL派送，自有账号；卡派：整车专送，零担拼车，自有车队。'
          },
          {
            title:'英国卡航',
            activeName:'first',
            icon:this.$ossUrl+'images/business/overSea/GB.png',
            channelData:'深圳发车到伦敦，14-18个自然日；',
            goodData:'自营监管仓、境外车队签约，每天发车；',
            serviceData:'清关模式：<br>1.单票清关，100%客户自主vat，递延清关（清关不交vat）；<br>2.拒接双清包税；<br>清关点：LGG、CDG，海外自建监管仓、清关团队。<br>尾程派送：快递派：UPS/DPD/DHL派送，自有账号；卡派：整车专送，零担拼车，自有车队。'
          },
          {
            title:'中亚、俄罗斯卡航',
            activeName:'first',
            icon:null,
            channelData:'16-19个自然日可提取',
            goodData:'1.通达中亚五国、俄罗斯、白俄罗斯，每日发车；<br>2.自建公司，时效稳定；',
            serviceData:null
          },
          {
            title:'DG卡航运输',
            activeName:'second',
            icon:null,
            channelData:null,
            goodData:'1.发车频率高，每周3-5班，全程门到门运输时效15-18天<br>2.根据带电、不带电，含MSDS等不同需求，个性化定制解决方案',
            serviceData:null
          },
      ]
    }
  },
  methods: {
    setActive(item,index) {
    if(index === 1){
      this.$router.push({
        name:'sea'
      })
    }else if(index === 2){
      this.$router.push({
        name:'road'
      })
    }else if(index === 3){
      this.$router.push({
        name:'air'
      })
    }else {
      this.$router.push({
        name:'business'
      })
    }
    // this.activeIndex = index;
    

  },
  }
};
</script>
<style src="../index.css" scoped>


</style>